import * as React from "react";
import { Modal } from "Components/General/Modal/GenericModal";
import { observer } from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import { taskModalStore } from "../Stores/TaskModalStore";
import { I18N_NS } from "Config/i18n";
import { TaskForm } from "./TaskForm";

interface TaskModalProps extends WithTranslation {}

export const TaskModal = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<TaskModalProps, {}> {
      public render() {
        const { t } = this.props;
        return (
          <Modal
            maskClosable={true}
            destroyOnHidden={true}
            title={t("Create task")}
            open={taskModalStore.isVisible}
            width={"100%"}
            style={{ maxWidth: 800, top: 20 }}
            zIndex={1012}
            onCancel={() => taskModalStore.toggleModal("task", true)}
            footer={null}
          >
            <TaskForm />
          </Modal>
        );
      }
    }
  )
);
